<template>
	<div class="eb-card eb-card-mesdispos">
		<EbHeading level="h2">Mes disponibilités</EbHeading>
    <EbLinkButton :to="{name: 'dispos'}" class="eb-card-button primary small">Modifier <span class="sr-only">mes disponibilités</span></EbLinkButton>

		<div v-if="dispos" class="sm:col-span-2">
			<EbHeading level="h3">Actuellement</EbHeading>
			<p v-if="dispos.dispoActuelle && dispos.dispoActuelle.aucuneDispoActuelle">Vous avez indiqué n’avoir aucune disponibilité actuellement.</p>
			<p v-else-if="dispos.dispoActuelle && !dispos.dispoActuelle.dispoActuelle">Vous n’avez renseigné aucune disponibilité actuellement.</p>
			<ul v-else class="list">
				<li v-for="d in realDispoActuelle">
					<strong>De {{ d.libelleTrancheAgeSolis }}</strong>
					<ul>
            <li>
              {{d.nombrePlaces}} place{{d.nombrePlaces>1?'s':''}}
            </li>  
					</ul>
				</li>
				<li v-if="dispos.dispoActuelle.dispoPeriscolaire">Je suis disponible pour de la périscolaire</li>
				<li v-if="dispos.dispoActuelle.dispoVacancesScolaires">Je suis disponible pour les vacances scolaires</li>
			</ul>

			<EbHeading level="h3">À venir</EbHeading>
			<p v-if="dispos && !dispos.disposFutures">Vous n’avez renseigné aucune disponibilité future.</p>

			<ul>
				<li v-for="df in dispos.disposFutures">
          <strong>À partir du <time :datetime="df.dateDebut">{{getLongDate(df.dateDebut)}}</time></strong>
					<ul>
            <li>
              De {{df.libelleTrancheAgeSolis}}
            </li>
					</ul>
				</li>
			</ul>
      
		</div>
    
	</div>
</template>

<script>
export default {
  name: 'mesDispos',
	data() {
		return {
      dispos: null
		}
	},
	mounted() {
		this.getDisponibilites()
	},
	computed: {
		// Nécessaire pour supprimer les dispos à 0 renvoyées par l'API
		realDispoActuelle: function () {
			return this.dispos.dispoActuelle.disposTranchesAgeSolis.filter(x => x.nombrePlaces > 0)
    }
	},
	methods: {
		getDisponibilites: async function () {
      await this.$http.get('assmat/disponibilites')
      .then(resp => {
				this.dispos = resp.data
			})
    }
  }
}
</script>

<style lang="scss" scoped>
.eb-card-mesdispos {
	font-size: $eb-font-size-s;
  h4, p {
		padding-left: $eb-space-m;
	}
	li {
		list-style-position: inside;
	}
  .eb-card-button {
    margin: 0;
  }
}
</style>